<template>
  <div>
    <select v-bind:value="value" v-on:input="$emit('input', $event.target.value)" :disabled="readonly" v-on:change="onChange">
      <option :value="null">Ønsker ikke at oplyse</option>
      <option value="Female">Kvinde</option>
      <option value="Male">Mand</option>
      <option value="Undefined">Andet</option>
    </select>
    <label>{{ label }}</label>
  </div>
</template>
<script>
export default {
  name: 'InputSelect',
  props: {
    value: {
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    validation: {
      type: String,
      default: '',
    },
    readonly: {
      default: null,
    },
    autocomplete: {
      type: String,
      autocomplete: null,
    },
  },
  data() {
    return {
      genderClass: false,
    }
  },

  methods: {
    onChange(event) {
      if (event.target.value != '') {
        this.genderClass = true
      }
    },
  },
}
</script>
